import PageShell from "../components/PageShell";
import { viewsFor } from "../content/views";
import seoPages from "../content/seo-pages.json";

const views = viewsFor("insights");
const seo = seoPages["/insights"];

export default function Insights() {
  return (
    <PageShell
      title={seo.title}
      description={seo.description}
      bodyClass=""
      dataFrame={null}
      views={views}
    />
  );
}
